<template>
  <div>
    <HeadBanner
      v-if="_.get(this.$store.state.current_content, 'secondary.HeadBanner.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.HeadBanner.data')"
    />
    <Breadcrumb />

    <div class="container layout-outer flex-box">
      <div class="layout-left">
        <LayoutContent
                :itemData="$store.state.current_content"
                v-if="$store.state.current_content"
        />
      </div>
      <div class="layout-right">
        <ApplicationLinkBox
                v-if="
              _.get(
                $store.state.current_content,
                'secondary.custom_banner.conf.enabled'
              ) == 1
            "
                :itemData="
              _.get(
                this.$store.state.current_content,
                'secondary.custom_banner'
              )
            "
        />
        <HowToApply
                :itemData="_.get($store.state.current_content, 'secondary.right_panel.conf')"
                v-if="_.get($store.state.current_content, 'secondary.right_panel.conf.enabled')==1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import LayoutContent from "@/components/LayoutContent";
import ApplicationLinkBox from "@/components/ApplicationLinkBox";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    LayoutContent,
    ApplicationLinkBox
  },
  computed: {
    getServiceRaits() {
      return this.$store.getters.getServiceRaits;
    },
  },
};
</script>
